import Vue from "vue";
import Router from "vue-router";
import store from "@/store";
import register from "@/router/register";
import onboarding from "@/router/onboarding";
import services from "@/router/services";
import users from "@/router/users";

Vue.use(Router);

const routes = [
  {
    path: "/",
    name: "landing",
    component: () => import("@/views/Landing.vue"),
    meta: {
      title: "Self-Assessment and Quality Improvement Planning Portal"
    }
  },
  register,
  onboarding,
  services,
  users,
  {
    path: '/logout',
    name: 'logout',
    beforeEnter: () => {
      router.app.$OAuth.logout()
    }
  }
];

const router = new Router({
  mode: "history",
  scrollBehavior: () => {
    return { x: 0, y: 0 };
  },
  base: process.env.BASE_URL,
  routes
});

router.beforeEach( (to, _from, next) => {  
  if (to.matched.some(r => r.meta.requiresService) && typeof store.getters.getService.seNumber === "undefined" || to.matched.some(r => r.meta.requiresService) && store.getters.getService.seNumber === "") {
    next("/services/dashboard")
  }

  if (router.app.$OAuth.profile) {
    var profileRoles = router.app.$OAuth.profile.roles;
    const validRoles = ["NONGOV.CENTREDIRECTOR", "SCHOOL.PRINCIPAL"];
    var rolesArray = [];
    if(Array.isArray(profileRoles)) {
      rolesArray = [...profileRoles];
    } else {
      rolesArray.push(profileRoles);
    }
    const filteredRole = validRoles.filter(value => rolesArray.includes(value));
    const aclArr = Array.isArray(router.app.$OAuth.profile.acl) ? router.app.$OAuth.profile.acl : [router.app.$OAuth.profile.acl];

    //var isVerifiedDirector = (filteredRole.length > 0 || router.app.$OAuth.profile.acl.some(role => role.match(/TTSDS Director/))) ? true : false;
    //var isCentreDirector = router.app.$OAuth.profile.acl.includes(`${store.getters.getService.seNumber} TTSDS Director`) || false;

    var isVerifiedDirector = (filteredRole.length > 0 || aclArr.some(role => role.match(/TTSDS Director/))) ? true : false;
    var isCentreDirector = aclArr.includes(`${store.getters.getService.seNumber} TTSDS Director`) || false;
  }

  if (to.matched.some(r => r.meta.requiresVerifiedDirector) && !isVerifiedDirector || to.matched.some(r => r.meta.requiresCentreDirector) && !isCentreDirector) {
    next("/services/dashboard")
  }

  const title = to.matched
    .slice()
    .reverse()
    .find(r => r.meta && r.meta.title);
  if (title) document.title = title.meta.title;
  next();
});

export default router;
